import { Button, Flex, Input, Modal } from "src/elements";
import { useEffect, useState } from "react";
import { useApi } from "src/api";
import { useModals } from "src/components/Modals";
import { useLoaders } from "src/components/InlineLoader";
import { RoutePutUsers_userId_Password } from "@CommonApi/users/_userId_/password";
import { useAtom } from "jotai";
import { resetPasswordUserAtom } from "./store/atoms";
import { isPasswordValid, validatePassword } from "src/utils/passwordValidation";
import { useToasts } from "src/components/Toasts";

export const ResetUserPasswordModal = () => {
  const { closeModal } = useModals();
  const { putUserPasswordApi } = useApi();
  const { hasLoader } = useLoaders();
  const { toast } = useToasts();
  const [userData, setUserData] = useAtom(resetPasswordUserAtom);

  const [newPassword, setNewPassword] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isResetSuccessful, setIsResetSuccessful] = useState(false);
  const isResetLoading = hasLoader(RoutePutUsers_userId_Password);

  useEffect(() => {
    return () => {
      setUserData(null);
    };
  }, []);

  const newPasswordError = validatePassword(newPassword);

  const resetPassword = async () => {
    if (!userData) return;

    const response = await putUserPasswordApi(userData.id, { newPassword });

    if (response) {
      setIsResetSuccessful(true);
      toast({ type: "SUCCESS", title: "Password reset successfully" });

      setTimeout(() => {
        closeModal("ResetUserPasswordModal");
      }, 1000);
    }
  };

  return (
    <Modal
      name="ResetUserPasswordModal"
      title={
        userData
          ? `Reset Password for ${userData.firstName} ${userData.lastName}`
          : "Reset Password"
      }
      width="320px"
    >
      <Flex padding="20px" column gap="20px">
        <Input
          type={isPasswordVisible ? "text" : "password"}
          value={newPassword}
          setValue={setNewPassword}
          title="New Password"
          placeholder="Enter new password"
          error={newPasswordError}
          rightIcon={{
            name: isPasswordVisible ? "eyeOn" : "eyeOff",
            onClick: () => setIsPasswordVisible(!isPasswordVisible),
          }}
        />

        <Flex justify="center">
          <Button
            isDisabled={!isPasswordValid(newPassword)}
            isLoading={isResetLoading}
            isSuccessful={isResetSuccessful}
            onClick={resetPassword}
          >
            Reset Password
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
